import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CurrentPageWatcherService } from '../utils/CurrentPageWatcher';

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.css']
})
export class FaqComponent implements OnInit {
  title: string = "Frequently Asked Questions";

  q01: boolean = false;
  q02: boolean = false;
  q03: boolean = false;
  q04: boolean = false;
  q05: boolean = false;
  q06: boolean = false;
  q07: boolean = false;
  q08: boolean = false;
  q09: boolean = false;
  q10: boolean = false;
  q11: boolean = false;
  q12: boolean = false;
  q13: boolean = false;
  q14: boolean = false;
  q15: boolean = false;
  q16: boolean = false;
  q17: boolean = false;
  q18: boolean = false;
  q19: boolean = false;
  q20: boolean = false;
  q21: boolean = false;
  q22: boolean = false;
  q23: boolean = false;
  q24: boolean = false;

  constructor(private router: Router, private currentPageWatcher: CurrentPageWatcherService) {
    this.currentPageWatcher.notifyLeftMenuDisplay().emit(false);


  }

  open(question: number) {
    console.log(question);
    switch (question) {
     
      case 1:
          if (this.q01 == false) {
            this.q01 = true;
          } else {
            this.q01 = false;
          }
        break;
      case 2:
          if (this.q02 == false) {
            this.q02 = true;
          } else {
            this.q02 = false;
          }
        break;
      case 3:
          if (this.q03 == false) {
            this.q03 = true;
          } else {
            this.q03 = false;
          }
        break;
      case 4:
          if (this.q04 == false) {
            this.q04 = true;
          } else {
            this.q04 = false;
          }
        break;
      case 5:
          if (this.q05 == false) {
            this.q05 = true;
          } else {
            this.q05 = false;
          }
        break;
      case 6:
          if (this.q06 == false) {
            this.q06 = true;
          } else {
            this.q06 = false;
          }
        break;
      case 7:
          if (this.q07 == false) {
            this.q07 = true;
          } else {
            this.q07 = false;
          }
        break;
      case 8:
          if (this.q08 == false) {
            this.q08 = true;
          } else {
            this.q08 = false;
          }
        break;
      case 9:
          if (this.q09 == false) {
            this.q09 = true;
          } else {
            this.q09 = false;
          }
        break;
      case 10:
          if (this.q10 == false) {
            this.q10 = true;
          } else {
            this.q10 = false;
          }
        break;
      case 11:
          if (this.q11 == false) {
            this.q11 = true;
          } else {
            this.q11 = false;
          }
        break;
      case 12:
          if (this.q12 == false) {
            this.q12 = true;
          } else {
            this.q12 = false;
          }
        break;
      case 13:
          if (this.q13 == false) {
            this.q13 = true;
          } else {
            this.q13 = false;
          }
        break;
      case 14:
          if (this.q14 == false) {
            this.q14 = true;
          } else {
            this.q14 = false;
          }
        break;
      case 15:
          if (this.q15 == false) {
            this.q15 = true;
          } else {
            this.q15 = false;
          }
        break;
      case 16:
          if (this.q16 == false) {
            this.q16 = true;
          } else {
            this.q16 = false;
          }
        break;
      case 17:
          if (this.q17 == false) {
            this.q17 = true;
          } else {
            this.q17 = false;
          }
        break;
      case 18:
          if (this.q18 == false) {
            this.q18 = true;
          } else {
            this.q18 = false;
          }
        break;
      case 19:
          if (this.q19 == false) {
            this.q19 = true;
          } else {
            this.q19 = false;
          }
        break;
      case 20:
          if (this.q20 == false) {
            this.q20 = true;
          } else {
            this.q20 = false;
          }
        break;
      case 21:
          if (this.q21 == false) {
            this.q21 = true;
          } else {
            this.q21 = false;
          }
        break;
      case 22:
          if (this.q22 == false) {
            this.q22 = true;
          } else {
            this.q22 = false;
          }
        break;
      case 23:
          if (this.q23 == false) {
            this.q23 = true;
          } else {
            this.q23 = false;
          }
        break;
      case 24:
          if (this.q24 == false) {
            this.q24 = true;
          } else {
            this.q24 = false;
          }
        break;


      default:
        break;
    }

  }

  close(question: number) {
    switch (question) {
      case 1:
        this.q01 = false;
        break;
      case 2:
        this.q02 = false;
        break;
      case 3:
        this.q03 = false;
        break;
      case 4:
        this.q04 = false;
        break;
      case 5:
        this.q05 = false;
        break;
      case 6:
        this.q06 = false;
        break;
      case 7:
        this.q07 = false;
        break;
      case 8:
        this.q08 = false;
        break;
      case 9:
        this.q09 = false;
        break;
      case 10:
        this.q10 = false;
        break;
      case 11:
        this.q11 = false;
        break;
      case 12:
        this.q12 = false;
        break;
      case 13:
        this.q13 = false;
        break;
      case 14:
        this.q14 = false;
        break;
      case 15:
        this.q15 = false;
        break;
      case 16:
        this.q16 = false;
        break;
      case 17:
        this.q17 = false;
        break;
      case 18:
        this.q18 = false;
        break;
      case 19:
        this.q19 = false;
        break;
      case 20:
        this.q20 = false;
        break;
      case 21:
        this.q21 = false;
        break;
      case 22:
        this.q22 = false;
        break;
      case 23:
        this.q23 = false;
        break;
      case 24:
        this.q24 = false;
        break;

      default:
        break;
    }

  }



  ngOnInit() {
    this.currentPageWatcher.pageChanged().emit(this.title)
  }

  goBackHome() {
    this.router.navigate(['/home']);
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/faq/faq.component.ts